import { SelectSearchField } from 'components'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'
import UsersApiV2 from 'api/v2/admins/users-api-v2'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool,
  onSelect : PropTypes.func,
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true,
  onSelect : (selectedOption) => {},
}

/**
 * Search field to select phone code by name or phone code.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {function} onSelect - (selectedOption) => void
 */
const PhoneCodeSelectSearchField = ({
  name,
  label,
  required,
  onSelect,
  ...props
}) => {

  const { setFieldError, setFieldTouched } = useFormikContext()

  const [ searchPhoneCodes, setSearchPhoneCodes ] = useState([])
  const [ isSearchLoading, setSearchLoading ]     = useState(false)
  let phoneCodeSearchTimeout                      = null

  // search phone code by name or phone code.
  const getPhoneCodes = (keyword) => {
    setSearchLoading(true)
    const additionalFilters = {
      q: keyword
    }
    UsersApiV2.phone_codes({ additionalFilters: additionalFilters })
      .then((response) => {
        setSearchPhoneCodes(response.data.phone_codes)
      })
      .catch(() => {
        setFieldError(name, 'Searching for Phone Code failed.')
        setFieldTouched(name, true, false)
      })
      .finally(() => setSearchLoading(false))
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.phone_code }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.name }</span>
    </>
  )
  const getSelectedOptionLabel = (option) => (
    option
  )

  // handler to search phone codes
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    if (phoneCodeSearchTimeout) clearTimeout(phoneCodeSearchTimeout)
    phoneCodeSearchTimeout = setTimeout(() => {
      getPhoneCodes(searchText)
    }, 700)
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Cari nama negara atau phone code langsung.'
      dataList={ searchPhoneCodes }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      getSelectedOptionLabel={ getSelectedOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        onSelect(selectedOption)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

PhoneCodeSelectSearchField.propTypes    = propTypes
PhoneCodeSelectSearchField.defaultProps = defaultProps

export default PhoneCodeSelectSearchField
